/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Бичээд үзээрэй',
	Advanced: 'Дэвшилтэт',
	'About Jodit': 'Jodit-ын талаар ',
	'Jodit Editor': 'Jodit програм',
	"Jodit User's Guide": 'Jodit гарын авлага',
	'contains detailed help for using':
		'хэрэглээний талаар дэлгэрэнгүй мэдээллийг агуулна',
	'For information about the license, please go to our website:':
		'Лицензийн мэдээллийг манай вэб хуудаснаас авна уу:',
	'Buy full version': 'Бүрэн хувилбар худалдан авах',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Зохиогчийн эрх хамгаалагдсан © XDSoft.net - Chupurnov Valeriy. Бүх эрхийг эзэмшинэ.',
	Anchor: 'Холбоо барих',
	'Open in new tab': 'Шинэ табаар нээх',
	'Open in fullsize': 'Бүтэн дэлгэцээр нээх',
	'Clear Formatting': 'Форматыг арилгах',
	'Fill color or set the text color':
		'Өнгөөр будах эсвэл текстийн өнгө сонгох',
	Redo: 'Дахих',
	Undo: 'Буцаах',
	Bold: 'Тод',
	Italic: 'Налуу',
	'Insert Unordered List': 'Тэмдэгт жагсаалт нэмэх',
	'Insert Ordered List': 'Дугаарт жагсаалт нэмэх',
	'Align Center': 'Голлож байрлуулах',
	'Align Justify': 'Тэгшитгэн байрлуулах',
	'Align Left': 'Зүүнд байрлуулах',
	'Align Right': 'Баруунд байрлуулах',
	'Insert Horizontal Line': 'Хэвтээ зураас нэмэх',
	'Insert Image': 'Зураг нэмэх',
	'Insert file': 'Файл нэмэх',
	'Insert youtube/vimeo video': 'Youtube/Vimeo видео нэмэх',
	'Insert link': 'Холбоос нэмэх',
	'Font size': 'Фонтын хэмжээ',
	'Font family': 'Фонтын бүл',
	'Insert format block': 'Блок нэмэх',
	Normal: 'Хэвийн',
	'Heading 1': 'Гарчиг 1',
	'Heading 2': 'Гарчиг 2',
	'Heading 3': 'Гарчиг 3',
	'Heading 4': 'Гарчиг 4',
	Quote: 'Ишлэл',
	Code: 'Код',
	Insert: 'Оруулах',
	'Insert table': 'Хүснэгт оруулах',
	'Decrease Indent': 'Доголын зай хасах',
	'Increase Indent': 'Доголын зай нэмэх',
	'Select Special Character': 'Тусгай тэмдэгт сонгох',
	'Insert Special Character': 'Тусгай тэмдэгт нэмэх',
	'Paint format': 'Зургийн формат',
	'Change mode': 'Горим өөрчлөх',
	Margins: 'Цаасны зай',
	top: 'Дээрээс',
	right: 'Баруунаас',
	bottom: 'Доороос',
	left: 'Зүүнээс',
	Styles: 'CSS стиль',
	Classes: 'CSS анги',
	Align: 'Байрлуулах',
	Right: 'Баруун',
	Center: 'Төв',
	Left: 'Зүүн',
	'--Not Set--': '--Тодорхойгүй--',
	Src: 'Эх үүсвэр',
	Title: 'Гарчиг',
	Alternative: 'Алтернатив текст',
	Link: 'Холбоос',
	'Open link in new tab': 'Холбоосыг шинэ хавтсанд нээх',
	Image: 'Зураг',
	file: 'Файл',
	'Image properties': 'Зургийн үзүүлэлт',
	Cancel: 'Цуцлах',
	Ok: 'Ok',
	'Your code is similar to HTML. Keep as HTML?':
		'Таны код HTML кодтой адил байна. HTML форматаар үргэлжлүүлэх үү?',
	'Paste as HTML': 'HTML байдлаар буулгах',
	Keep: 'Хадгалах',
	Clean: 'Цэвэрлэх',
	'Insert as Text': 'Текст байдлаар нэмэх',
	'Word Paste Detected': 'Word байдлаар буулгасан байна',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Буулгасан агуулга Microsoft Word/Excel форматтай байна. Энэ форматыг хэвээр хадгалах уу эсвэл арилгах уу?',
	'Insert only Text': 'Зөвхөн текст оруулах',
	'File Browser': 'Файлын цонх',
	'Error on load list': 'Жагсаалт татах үед алдаа гарлаа',
	'Error on load folders': 'Хавтас татах үед алдаа гарлаа',
	'Are you sure?': 'Итгэлтэй байна уу?',
	'Enter Directory name': 'Хавтсын нэр оруулах',
	'Create directory': 'Хавтас үүсгэх',
	'type name': 'Нэр бичих',
	'Drop image': 'Зураг буулгах',
	'Drop file': 'Файл буулгах',
	'or click': 'эсвэл товш',
	'Alternative text': 'Алтернатив текст',
	Browse: 'Үзэх',
	Upload: 'Байршуулах',
	Background: 'Арын зураг',
	Text: 'Текст',
	Top: 'Дээр',
	Middle: 'Дунд',
	Bottom: 'Доор',
	'Insert column before': 'Урд нь багана нэмэх',
	'Insert column after': 'Ард нь багана нэмэх',
	'Insert row above': 'Дээр нь мөр нэмэх',
	'Insert row below': 'Доор нь мөр нэмэх',
	'Delete table': 'Хүснэгт устгах',
	'Delete row': 'Мөр устгах',
	'Delete column': 'Багана устгах',
	'Empty cell': 'Нүд цэвэрлэх',
	Delete: 'Устгах',
	'Strike through': 'Дээгүүр зураас',
	Underline: 'Доогуур зураас',
	Break: 'Мөрийг таслах',
	'Search for': 'Хайх',
	'Replace with': 'Үүгээр солих',
	Replace: 'Солих',
	Edit: 'Засах',
	'Vertical align': 'Босоо эгнүүлэх',
	'Horizontal align': 'Хэвтээ эгнүүлэх',
	Filter: 'Шүүх',
	'Sort by changed': 'Сүүлд өөрчлөгдсөнөөр жагсаах',
	'Sort by name': 'Нэрээр жагсаах',
	'Sort by size': 'Хэмжээгээр жагсаах',
	'Add folder': 'Хавтас нэмэх',
	Split: 'Задлах',
	'Split vertical': 'Баганаар задлах',
	'Split horizontal': 'Мөрөөр задлах',
	Merge: 'Нэгтгэх',
	'Add column': 'Багана нэмэх',
	'Add row': 'Мөр нэмэх',
	Border: 'Хүрээ',
	'Embed code': 'Код оруулах',
	Update: 'Шинэчлэх',
	superscript: 'Дээд индекс',
	subscript: 'Доод индекс',
	'Cut selection': 'Сонголтыг таслах',
	Paste: 'Буулгах',
	'Choose Content to Paste': 'Буулгах агуулгаа сонгоно уу',
	'Chars: %d': 'Тэмдэгт: %d',
	'Words: %d': 'Үг: %d',
	All: 'Бүгдийг',
	'Select %s': 'Сонго: %s',
	'Select all': 'Бүгдийг сонго',
	source: 'Эх үүсвэр',
	bold: 'Тод',
	italic: 'Налуу',
	brush: 'Будах',
	link: 'Холбоос',
	undo: 'Буцаах',
	redo: 'Дахих',
	table: 'Хүснэгт',
	image: 'Зураг',
	eraser: 'Баллуур',
	paragraph: 'Параграф',
	fontsize: 'Фонтын хэмжээ',
	video: 'Видео',
	font: 'Фонт',
	about: 'Тухай',
	print: 'Хэвлэх',
	underline: 'Доогуур зураас',
	strikethrough: 'Дээгүүр зураас',
	indent: 'Догол нэмэх',
	outdent: 'Догол багасгах',
	fullsize: 'Бүтэн дэлгэц',
	shrink: 'Багасга',
	hr: 'Хаалт',
	ul: 'Тэмдэгт жагсаалт',
	ol: 'Дугаарласан жагсаалт',
	cut: 'Таслах',
	selectall: 'Бүгдийг сонго',
	'Open link': 'Холбоос нээх',
	'Edit link': 'Холбоос засах',
	'No follow': 'Nofollow özelliği',
	Unlink: 'Холбоос салгах',
	Eye: 'Нүд',
	pencil: 'Засах',
	' URL': 'URL',
	Reset: 'Буцаах',
	Save: 'Хадгалах',
	'Save as ...': 'Өөрөөр хадгалах',
	Resize: 'Хэмжээг өөрчил',
	Crop: 'Тайрах',
	Width: 'Өргөн',
	Height: 'Өндөр',
	'Keep Aspect Ratio': 'Харьцааг хадгал',
	Yes: 'Тийм',
	No: 'Үгүй',
	Remove: 'Арилга',
	Select: 'Сонго',
	'You can only edit your own images. Download this image on the host?':
		'Та зөвхөн өөрийн зургуудаа янзлах боломжтой. Энэ зургийг өөр лүүгээ татмаар байна уу?',
	'The image has been successfully uploaded to the host!':
		'Зургийг хост руу амжилттай хадгалсан',
	palette: 'Палет',
	'There are no files': 'Энд ямар нэг файл алга',
	Rename: 'Шинээр нэрлэх',
	'Enter new name': 'Шинэ нэр оруулна уу',
	preview: 'Урьдчилан харах',
	download: 'Татах',
	'Paste from clipboard': 'Самбараас хуулах ',
	"Your browser doesn't support direct access to the clipboard.":
		'Энэ вэб хөтчөөс самбарт хандах эрх алга.',
	'Copy selection': 'Сонголтыг хуул',
	copy: 'Хуулах',
	'Border radius': 'Хүрээний радиус',
	'Show all': 'Бүгдийг харуулах',
	Apply: 'Хэрэгжүүл',
	'Please fill out this field': 'Энэ талбарыг бөглөнө үү',
	'Please enter a web address': 'Вэб хаягаа оруулна уу',
	Default: 'Үндсэн',
	Circle: 'Дугуй',
	Dot: 'Цэг',
	Quadrate: 'Дөрвөлжин',
	Find: 'Хайх',
	'Find Previous': 'Өмнөхийг ол',
	'Find Next': 'Дараагийнхийг ол',
	'Insert className': 'Бүлгийн нэрээ оруулна уу',
	'Press Alt for custom resizing':
		'Хэмжээсийг шинээр өөчрлөхийн тулд Alt товчин дээр дарна уу'
};
